/**
 * CouplingToggle.jsx
 *
 * TH-specific "Coupling required" toggle. Thin wrapper around ToggleCard
 * wired to DSCContext.toggles.coupling. Default OFF (matches legacy default
 * couplingRequired = false).
 *
 * Conditional availability (tracker #20): disabled until a rock-drill model
 * is selected in the shank-adapter slot — the coupling cascade
 * (`getCouplingThreadforRods`) requires mfr+model to produce options. Without
 * this gate, toggling ON with no model selected produces an empty couplings
 * slot with no dropdown options, which is confusing.
 *
 * Citations (port-first):
 *  - Legacy LWC addToDSC.html lines 3-13 — the Coupling required toggle.
 *  - Plan SP0 row CouplingToggle.jsx.
 *  - Plan SP2.2 dropdown-wiring table.
 *  - Tracker #20: conditional toggle availability.
 *
 * @module components/dsc/CouplingToggle
 * @since 2026-05-20 (Group E SP2 — replaces SP1 scaffold)
 */

import { useDSCToggle, useDSC } from '@contexts/DSCContext';
import ToggleCard from './ToggleCard';

export default function CouplingToggle() {
  const { value, setValue } = useDSCToggle('coupling');
  const { state } = useDSC();
  const shankSel = state.selections?.['shank-adapter'];
  const hasModel = !!(shankSel?.model);

  return (
    <ToggleCard
      id="dsc-coupling-toggle"
      label="Coupling required"
      helperText="Add a coupling sleeve between shank and rod"
      value={value}
      onChange={setValue}
      disabled={!hasModel}
      disabledReason="Select a rock drill model first"
      dataTestid="coupling-toggle"
    />
  );
}
